import styled from 'styled-components';

const Container = styled.div`
  display: flex;
	flex-direction: column;
	justify-content: space-between;
	margin-left: 40px;

	@media (max-width: 1200px) {
		margin-left: 0;
		width: 100%;
		flex-direction: row;
	}
`;

const Detail = styled.div`
  display: flex;
	flex-direction: column;
	padding: 0 8px;
`;

const DetailValue = styled.p`
	height: 24px;
	display: flex;
	align-items: center;
`;

const DetailLabel = styled(DetailValue)`
  font-weight: bold;
	color: #787878;
`;

export {
	Container,
	Detail,
	DetailLabel,
	DetailValue,
}
